import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { Tracking } from '../../../../../../pages/project/settings/Tracking';
import { Centered } from '../../../../../../components/atoms/layouts/Centered';
import { Loader } from '../../../../../../components/molecules/loader/Loader';
import { getProjectQuizesQueryOptions } from '../../../../../../rest-api/queries/sharedQueries';

export const Route = createFileRoute('/_private/_home/project/$project_id/settings/tracking')({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(getProjectQuizesQueryOptions(context.apiClient, params.project_id)),
  component: TrackingRoute,
  pendingComponent: () => (
    <Centered>
      <Loader label="Loading tracking settings..." />
    </Centered>
  ),
});

function TrackingRoute() {
  const { project_id } = Route.useParams();
  const { apiClient } = Route.useRouteContext();
  return <Tracking projectId={project_id} portalApiClient={apiClient} />;
}
